import { render, staticRenderFns } from "./GeneticFitInfoModal.vue?vue&type=template&id=d2a4345e&scoped=true"
import script from "./GeneticFitInfoModal.vue?vue&type=script&lang=js"
export * from "./GeneticFitInfoModal.vue?vue&type=script&lang=js"
import style0 from "./GeneticFitInfoModal.vue?vue&type=style&index=0&id=d2a4345e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a4345e",
  null
  
)

export default component.exports